export const contains = (
  superset: Set<unknown>,
  maybeSubset: Set<unknown>,
): boolean => {
  for (const child of maybeSubset) {
    if (!superset.has(child)) {
      return false;
    }
  }
  return true;
};
